import { render, staticRenderFns } from "./WCategories.vue?vue&type=template&id=17a28436&scoped=true&"
import script from "./WCategories.vue?vue&type=script&lang=js&"
export * from "./WCategories.vue?vue&type=script&lang=js&"
import style0 from "./WCategories.vue?vue&type=style&index=0&id=17a28436&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a28436",
  null
  
)

export default component.exports